import script from "./search-result-marker.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-result-marker.vue?vue&type=script&setup=true&lang=ts"

import "./search-result-marker.vue?vue&type=style&index=0&id=e3f5b146&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f5b146"]])

export default __exports__